<template>
  <div>
    <!--年月日-->
    <el-date-picker
      :disabled="disable"
      clearable
      v-if="config.rules.dateConfig.type == 'date'"
      v-model="value"
      value-format="yyyy-MM-dd"
      type="date"
      placeholder="选择日期"
    >
    </el-date-picker>
    <!--时分秒-->
    <el-time-picker
      :disabled="disable"
      clearable
      v-model="value"
      value-format="HH:mm:ss"
      v-else-if="config.rules.dateConfig.type == 'time'"
      placeholder="任意时间点"
    >
    </el-time-picker>
    <!--年月日时分秒-->
    <el-date-picker
      :disabled="disable"
      clearable
      v-else-if="config.rules.dateConfig.type == 'datetime'"
      v-model="value"
      value-format="yyyy-MM-dd HH:mm:ss"
      type="datetime"
      placeholder="选择日期时间"
    >
    </el-date-picker>
  </div>
</template>
<script>
export default {
  props: ["data", "config", "disable"],
  computed: {
    value: {
      get() {
        return this.data;
      },
      set(val) {
        this.$emit("update:data", val);
      },
    },
  },
};
</script>
